/* Nutrilight global behaviour (Rehaul 2026). Vanilla JS, no dependencies.
   - Marks <html> with .nl-js so CSS can enhance safely (content stays visible without JS).
   - Announcement bar: on narrow screens shows one message at a time with a soft fade.
     Respects prefers-reduced-motion (no auto-rotation, messages stay swipeable). */
(function () {
  'use strict';
  if (window.__nlGlobal) return;
  window.__nlGlobal = true;
  document.documentElement.classList.add('nl-js');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var narrow = window.matchMedia ? window.matchMedia('(max-width: 899px)') : { matches: false };

  function initAnnouncement(root) {
    var bars = (root || document).querySelectorAll('[data-nl-ann]');
    Array.prototype.forEach.call(bars, function (bar) {
      if (bar.__nl) return; bar.__nl = true;
      var items = bar.querySelectorAll('.nl-ann__item');
      if (items.length < 2 || reduce) return;
      bar.setAttribute('data-rotate', '');
      var i = 0, timer = null, speed = (parseInt(bar.getAttribute('data-speed'), 10) || 4) * 1000;
      items[0].classList.add('is-on');
      function show(n) {
        items[i].classList.remove('is-on');
        i = (n + items.length) % items.length;
        items[i].classList.add('is-on');
      }
      function start() { stop(); if (narrow.matches) timer = setInterval(function () { show(i + 1); }, speed); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      bar.addEventListener('focusin', stop);
      bar.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
      if (narrow.addEventListener) narrow.addEventListener('change', start);
      start();
    });
  }

  function init(root) { initAnnouncement(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
